import React from 'react';
import { ProfessorCalendar } from '../../../../../component/calendar/professor-calendar/professor-calendar';

export const ProfessorLecturesCalendar: React.FC<{ professorId: number }> = ({
  professorId,
}) => {
  return <ProfessorCalendar professorId={professorId} />;
};
